  <div
    id="floating-gallery"
    *ngIf="index !== undefined"
    tabindex="1"
    (keydown.escape)="closeGalleryDialog()"
    (touchstart)="touchStarted($event)"
    (touchmove)="touchMoved($event)"
    (touchend)="touchEnded($event)">
    <div id="floating-gallery-inner-cont">
      <button id="back-button" mat-icon-button (click)="nextImage(-1)">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div id="floating-gallery-image">
        <button
          id="close-button"
          mat-icon-button
          (click)="closeGalleryDialog()">
          <mat-icon>close</mat-icon>
        </button>
        <img
          src="{{
            restApiService.FILE_URL + images[index]
          }}"
          draggable="false"
          alt="" />
      </div>
      <button id="forward-button" mat-icon-button (click)="nextImage(1)">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>